<template>
<div v-if="auditSiteDevice.deviceCategoryId === METEOROLOGICAL_DEVICE_CATEGORY" class="normal-chart-group-wrapper">
  <dimension-weather-chart
    v-for="data in filterDataList"
    :key="data.id"
    :data-config="data"
    :dimension="dimension"
    :unit-prop="unitProp"
    :download-name="downloadName"
    style="flex:1 0 100%;"
  />
</div>
<div v-else class="normal-chart-group-wrapper">
  <x-y-chart
    v-for="data in filterDataList"
    :key="data.id"
    :data-config="data"
    :unit-prop="unitProp"
    download-name="常规因子"
    chart-type="line"
    :stack-type="0"
    data-time-format="MM月DD日HH时"
    chart-height="auto"
    style="flex:1 0 100%;"
  />
</div>
</template>

<script>
import BaseCompare from './BaseCompare'

import XYChart from '../../../../components/DataChart/XYChart'
import DimensionWeatherChart from '../../../../components/Data/ChartWrapper/DimensionWeatherChart'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

export default {
  name: 'AuditNormalDeviceCompareChart',
  extends: BaseCompare,
  components: {DimensionWeatherChart, XYChart},
  props: {
    selectedFactorIds: {
      required: true,
      type: Array
    },
    conditions: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      unitProp: 'stdUnit',
      dimension: 1
    }
  },
  computed: {
    METEOROLOGICAL_DEVICE_CATEGORY: () => process.env.METEOROLOGICAL_DEVICE_CATEGORY,
    downloadName: () => '气象5参数',
    minSiteSelectNumber () {
      return this.filterSites.length
    },
    profileSiteDevices () {
      return this._profileSiteDevices
    },
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(this.auditSiteDevice.deviceCategoryId, true)
      ]
    },
    filterDataList () {
      let selectedFactorIdMap = this.selectedFactorIds.reduce((map, factorId) => {
        map[factorId] = true
        return map
      }, {})

      return this.dataList.filter(data => selectedFactorIdMap[data.id]).map(item => {
        let seriesMap = {}

        for (let key in item.seriesMap) {
          seriesMap[key] = Object.values(item.seriesMap[key]).reduce((map, el) => {
            map[el.dataTime] = el

            if (el.auditFlag === 'DELETE' && (el.dasFlag === 'c' || el.dasFlag === 'C')) {
              map[el.dataTime][this.valueProp] = ''
            }
            return map
          }, {})
        }
        return {
          ...item,
          seriesMap: seriesMap
        }
      })
    }
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    }
  },
  watch: {
    filterDataList (filterDataList) {
      // console.log(filterDataList)
    }
  }
}
</script>

<style lang="scss" scoped>
.normal-chart-group-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px 0;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditNormalDeviceCompareChart.vue